<main id="main" class="about-template">
    <div class="jumbotron jumbotron-fluid m-0 bg-yellow d-flex justify-content-center align-items-center" style="background-image: url('./assets/images/plaza/toll-plaza-and-fees.webp?v=20242028'); background-size: cover; background-position: center; height: 70vh;">
        <div class="container ">
            <div class="row py-2 text-center">
                <div class="col">
                    <img src="./assets/images/plaza/toll-icon.svg?v=20241028" alt="Plaza">
                </div>
            </div>
            <div class="row py-2 justify-content-center align-items-center text-center text-white">
                <div class="col">
                    <h1 class="">Toll Plazas &amp; Fees</h1>
                    <h3 class="">On the N4 toll route</h3>
                    <p class="">There are six (6) mainline toll plazas and four (4) ramp plazas on the N4 Toll Route from east of Tshwane, at the Solomon Mahlangu off ramp, to Maputo in Mozambique.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="container p-sm-0">
        <div class="pt-5">
            <!-- <swiper [slidesPerView]="6" [spaceBetween]="10" >         -->
            <swiper>        
                <ng-template swiperSlide *ngFor="let slide of this.apiContent.body?.Data; index as i">
                    <div class="swiper-in text-center block-bg-yellow p-0" [attr.id]="i" (click)="tollSelected($event)" >
                        <div class="p-3 related-block-content" [attr.id]="i">
                            <div class="cta-img d-flex">
                                <div class="related-block-content-headings">
                                    <h5 class="mt-3 mb-0 black-text" [attr.id]="i">{{slide.name}}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </swiper>
            <div id="all" class="text-right text-grey mt-2" (click)="tollSelected($event)">View All</div>
        </div>
        <div class="toll-selected-container row justify-content-center pt-5 mx-1" *ngIf="this.tollSelectedContent !== ''">
            <div class="col">
                <div class="row justify-content-center mx-1" *ngIf="this.tollSelectedContent !== '' && this.tollSelectedContentSingle == true">
                    <div class="tollcol tollcol-single">
                        <div class="row selected-header block-bg-yellow p-3 mb-2 justify-content-center">{{this.tollSelectedContent.name}}</div>
                        <div class="row selected-content py-2">
                            <div class="col">Vehicle Class</div>
                            <div class="col text-right">Cost</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 1</div>
                            <div class="col text-right">{{this.tollSelectedContent.currency}} {{this.tollSelectedContent.cat1}}.00</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 2</div>
                            <div class="col text-right">{{this.tollSelectedContent.currency}} {{this.tollSelectedContent.cat2}}.00</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 3</div>
                            <div class="col text-right">{{this.tollSelectedContent.currency}} {{this.tollSelectedContent.cat3}}.00</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 4</div>
                            <div class="col text-right">{{this.tollSelectedContent.currency}} {{this.tollSelectedContent.cat4}}.00</div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center" style="gap: 35px;" *ngIf="this.tollSelectedContent !== '' && this.tollSelectedContentSingle == false">
                    <div class="tollcol" *ngFor="let tolls of this.tollSelectedContent">
                        <div class="row selected-header block-bg-black p-3 mb-2 justify-content-center">{{tolls.name}}</div>
                        <div class="row selected-content py-2">
                            <div class="col">Vehicle Class</div>
                            <div class="col text-right">Cost</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 1</div>
                            <div class="col text-right">{{tolls.currency}} {{tolls.cat1}}.00</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 2</div>
                            <div class="col text-right">{{tolls.currency}} {{tolls.cat2}}.00</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 3</div>
                            <div class="col text-right">{{tolls.currency}} {{tolls.cat3}}.00</div>
                        </div>
                        <div class="row selected-content py-2">
                            <div class="col">Class 4</div>
                            <div class="col text-right">{{tolls.currency}} {{tolls.cat4}}.00</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container p-sm-0">
        <div id="" class="row py-5 related-blocks mx-sm-1 mx-sm-0">
            <div class="col-sm-12 col-md text-center block-bg-yellow p-0 mb-2">
                <a class="actionlink" href="" routerLink="/toll-plaza-and-fees" (click)="open(content2)">
                    <div class="p-3 related-block-content">
                        <div class="cta-img d-flex justify-content-center align-items-end" style="height: 280px;">
                            <img class="" src="./assets/images/plaza/get-a-tag-icon.png?v=20242028" style="height: 150px; position: absolute;" alt="Toll Green">
                            <div class="related-block-content-headings">
                                <h5 class="mt-3 mb-0 black-text">Get a Tag</h5>
                                <h6 class="mt-2 black-text">You must have sufficient funds in your tag account for the boom to open</h6>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-12 col-md text-center block-bg-yellow p-0 mb-2 mx-0 mx-md-5">
                <a class="actionlink p-0" href="" routerLink="/plazaconcessionrequirements">
                    <div class="p-3 related-block-content block-content-reverse">
                        <div class="cta-img d-flex justify-content-center align-items-start" style="height: 280px;">
                            <img class="" src="./assets/images/plaza/Tolls%20_%20Plaza%20Banners%20Icons_About%20Trac.png" style="height: 150px; position: absolute;" alt="Toll Green">
                            <div class="related-block-content-headings">
                                <h5 class="mt-3 mb-0 black-text">Concession Requirements</h5>
                                <h6 class="mt-2 black-text">Find out more</h6>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-12 col-md text-center block-bg-yellow p-0 mb-2 ">
                <a class="actionlink" href="" routerLink="/toll-plaza-and-fees" (click)="open(content3)">
                    <div class="p-3 related-block-content">
                        <div class="cta-img d-flex justify-content-center align-items-end" style="height: 280px;">
                            <img class="" src="./assets/images/plaza/tap-icon.png?v=20242028" style="height: 150px; position: absolute;" alt="Toll Green">
                            <div class="related-block-content-headings">
                                <h5 class="mt-3 mb-0 black-text">Tap ‘n Go</h5>
                                <h6 class="mt-2 black-text">Hassle free</h6>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-black">
        <div class="row pt-5 pb-4">
            <div class="col-sm-12 col-md-12">
                <h5 class="text-yellow text-center m-0 text-uppercase">Toll Fees</h5>
                <p class="text-yellow text-center">Effective 1 March 2024</p>
            </div>
        </div>
    </div>
    <div class="container py-5">
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <h3 class="text-center ">Payment Methods</h3>
                <p class="text-center">The following methods of payment are accepted on the N4 Toll Route:</p>
            </div>
        </div>
        <div class="row py-4">
            <div class="col-sm-12 col-md-6">
                <h4>RSA</h4>
                <div class="cont py-3">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 p-0">
                            <ul>
                                <li>Cash <sup>*</sup></li>
                                <li>Automatic Electronic Tag (<a class="pointer" style="text-decoration: underline;" (click)="open(content2)">Read
                                    More</a>)</li>
                                <li>Fleet Cards</li>
                                <li>Credit Cards**</li>
                                <li>Prepaid TRAC Debit Card (Issued By TRAC ONLY)</li>
                            </ul>
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <p class="m-0 text-grey" style="font-style: italic;"><sup>*</sup> Except Where Discounted Tariffs Are Applied For</p>
                            <p class="m-0 text-grey" style="font-style: italic;"><sup>**</sup> For Class 1 Vehicles ONLY. Master / Visa Accepted ONLY - NO Amex / Diners.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <h4>Mozambique</h4>
                <div class="cont py-3">
                    <div class="row">
                        <div class="col-sm-12 col-md-12 p-0">
                            <ul>
                                <li>Cash – Meticais, SA Rand & US Dollar <sup>*</sup></li>
                                <li>TRAC Mozambique E-tag <sup>**</sup></li>
                                <li>Prepaid TRAC Debit Card (Issued by TRAC ONLY)</li>
                            </ul>
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <p class="m-0 text-grey" style="font-style: italic;"><sup>*</sup> Except where discounted tariffs are applicable. Where payment in cash is tendered in SA Rand(New Notes) or US Dollar, change will be given in Meticais at an exchange rate determined by TRAC, and rounded down to the nearest Metical. No foreign coins are accepted. All payment in SA Rand(New Notes) or US$ must be tendered in notes</p>
                            <p class="m-0 text-grey" style="font-style: italic;"><sup>**</sup> Not Compatible With South Africa's Automatic Electronic Tag System</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-black">
        <div class="row pt-5 pb-4">
            <div class="col-sm-12 col-md-12">
                <h5 class="text-yellow text-center m-0 text-uppercase">FOR FURTHER ASSISTANCE, CLARIFICATION OR INFORMATION PLEASE CONTACT TRAC’S 24 HOUR HELPDESK:</h5>
            </div>
        </div>
        <div class="row pt-3 pb-5">
            <div class="col-sm-12 col-md-3 offset-md-3 text-left text-white">
                <h5 class="text-yellow">RSA</h5>
                <p>Tel:&nbsp;<a href="tel:0800872264">0800 87 22 64</a>/<a href="tel:0828814444">082 881 4444</a></p>
                <p>Email:&nbsp;<a href="mailto:helpdesk@tracn4.co.za">helpdesk@tracn4.co.za</a></p>
            </div>
            <div class="col-sm-12 col-md-3 text-left text-white">
                <h5 class="text-yellow">Mozambique</h5>
                <p>Tel:&nbsp;<a href="tel:0843434346">084 34 34 34 6</a></p>
                <p>Email:&nbsp;<a href="mailto:linhadocliente@tracn4.co.mz">linhadocliente@tracn4.co.mz</a></p>
            </div>
        </div>
    </div>
    <div class="container">
        <div id="relatedlinkstolls" class="row pt-5">
            <div class="col-sm-12 col-md-12">
                <h5 class="text-center text-uppercase ">Related Links</h5>
            </div>
        </div>
        <div id="" class="row pb-5 related-blocks mx-sm-1">
            <div class="col-sm-12 col-md text-center block-bg-yellow p-0 mb-2">
                <a class="actionlink" href="" routerLink="/toll-plaza-and-fees" (click)="open(content1)">
                    <div class="p-3 related-block-content">
                        <div class="cta-img d-flex justify-content-center align-items-end" style="height: 280px;">
                            <img class="" src="./assets/images/plaza/why-stop-icon.png?v=20242028" style="height: 150px; position: absolute;" alt="Toll Green">
                            <div class="related-block-content-headings">
                                <h5 class="mt-3 mb-0 black-text">Why Stop?</h5>
                                <h6 class="mt-2 black-text">Pay your toll without stopping at our express lane</h6>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-12 col-md text-center block-bg-yellow p-0 mb-2 mx-0 mx-md-5">
                <a class="actionlink p-0" href="" routerLink="/plazawhytoll">
                    <div class="p-3 related-block-content block-content-reverse">
                        <div class="cta-img d-flex justify-content-center align-items-start" style="height: 280px;">
                            <img class="" src="./assets/images/plaza/Tolls%20_%20Plaza%20Banners%20Icons_About%20Trac.png" style="height: 150px; position: absolute;" alt="Toll Green">
                            <div class="related-block-content-headings">
                                <h5 class="mt-3 mb-0 black-text">Why Toll?</h5>
                                <h6 class="mt-2 black-text">Why and how toll roads work for you</h6>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
            <div class="col-sm-12 col-md text-center block-bg-yellow p-0">
                <a class="actionlink" href="" routerLink="/toll-plaza-and-fees" (click)="open(content4)">
                    <div class="p-3 related-block-content">
                        <div class="cta-img d-flex justify-content-center align-items-end" style="height: 280px;">
                            <img class="" src="./assets/images/plaza/toll-tariff-icon.png?v=20242028" style="height: 150px; position: absolute;" alt="Toll Green">
                            <div class="related-block-content-headings">
                                <h5 class="mt-3 mb-0 black-text">Toll Tariff</h5>
                                <h6 class="mt-2 black-text">Adjustments N4 toll route (Maputo Corridor)</h6>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</main>

<ng-template #content1 let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title2">Why Stop ?</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <img src="./assets/images/home-tiles/why-stop-flyer.webp?v20240412"
             class="img-fluid"
             style=" width: 100%; max-width:100%; height:auto; "/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('close click')">Close</button>
    </div>
</ng-template>


<ng-template #content2 let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="">Why Queue?</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <img src="./assets/images/express-lane-flyers/ExpressLaneFlyer2-min-get-a-tag.jpg" class="img-fluid"
             style=" width: 100%; max-width:100%; height:auto; "/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('close click')">Close</button>
    </div>
</ng-template>

<ng-template #content3 let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Tap n Go</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <img src="./assets/images/express-lane-flyers/Website-Flyer-Tap-n-Go.webp?v=20240820" class="img-fluid"
             style=" width: 100%; max-width:100%; height:auto; "/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('close click')">Close</button>
    </div>
</ng-template>


<ng-template #content4 let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Toll Tariff Adjustment</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <img src="./assets/images/sanral/Toll-Tariffs-Digi-Set-240x240-2024-2.webp?v=202403-1" class="img-fluid"
             style=" width: 100%; max-width:100%; height:auto; "/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('close click')">Close</button>
    </div>
</ng-template>


<ng-template #content5 let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Sanral</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <img src="./assets/images/sanral/sanral-a3-poster.jpg" class="img-fluid"
             style=" width: 100%; max-width:100%; height:auto; "/>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('close click')">Close</button>
    </div>
</ng-template>

